import { FeatureTracking, FeatureTrackingOutput } from '../offers-tracking-model';

export class FeatureTrackingHelper {
    constructor(private rootElement: HTMLElement) {}

    public getFeatureTrackingFromHtml(): FeatureTracking {
        const featureTrackingData = this.rootElement.dataset.featureTracking;
        if (!featureTrackingData) {
            throw new Error('could not read custom data attribute "data-feature-tracking" from HTML');
        }
        return JSON.parse(featureTrackingData) as FeatureTracking;
    }

    public setFeatureTrackingInHtml(featureTracking: FeatureTracking): void {
        this.rootElement.dataset.featureTracking = JSON.stringify(featureTracking);
    }

    public generateFeatureTrackingOutput(featureTracking: FeatureTracking): FeatureTrackingOutput {
        const { offerVariations, ...parent } = featureTracking;
        const variationsParentId = parent.id;
        const flatArray: FeatureTrackingOutput = [parent];
        for (const variation of offerVariations) {
            const { offersVariationServices, ...variationParent } = variation;
            const serviceParentId = variationParent.id;
            flatArray.push({ parentId: variationsParentId, ...variationParent });
            for (const offersVariationService of offersVariationServices) {
                flatArray.push({ parentId: serviceParentId, ...offersVariationService });
            }
        }
        return flatArray;
    }
}
